module.exports = __webpack_public_path__ + "img/hic-liver-cancer-male.298b1484.png";